  <header>
    <div class="headerSwatches">
      <span class="color1">. </span>
      <span class="color2">.</span>
      <span class="color3">.</span>
      <span class="color4">.</span>
      <span class="color5">.</span>
      <span class="color6">.</span>
      <span class="color7">.</span>
      <span class="color8">.</span>
      <span class="color9">.</span>
    </div>


    <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow mb-3">
      <div class="container">
        <a class="navbar-brand" href="/" ><img src="logo-patempo.png" height="39" alt="" /></a>
        <p class="navbar-brand-desciption">Patent Pendency</p>

        <button *ngIf="isLoggedIn"
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target=".navbar-collapse"
                aria-label="Toggle navigation"
                [attr.aria-expanded]="isExpanded"
                (click)="toggle()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse"
             [ngClass]="{ show: isExpanded }">

          <ul *ngIf="isLoggedIn else notLoggedIn" class="navbar-nav flex-grow">
            <li class="nav-item">
              <a *ngIf="currentPageIsCalculator else elseBlockCalculator" class="nav-link hightligthed" href="/"> Calculator </a>
              <ng-template #elseBlockCalculator>
                <a class="nav-link " href="/">Calculator</a>
              </ng-template>
            </li>
            <li class="nav-item">
              <ng-template #elseBlock>
                <a class="nav-link" id="aboutPage" href="/about">About Patempo</a>
              </ng-template>
              <a *ngIf="currentPageIsAbout else elseBlock" class="nav-link hightligthed" href="/"> About Patempo </a>
            </li>
            <li class="nav-item" *ngIf="isAdmin">
              <a class="nav-link" [routerLink]="['/config/edit-step']">Configuration </a>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ userFullName }}
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <button class="dropdown-item" (click)="updateUserProfile()">Update Profile</button>
                <button class="dropdown-item" (click)="updateUserPassword()">Update Password</button>
                <div *ngIf="isAdmin" class="dropdown-divider"></div>
                <a *ngIf="isAdmin" class="dropdown-item" [routerLink]="['/config/edit-user']">Users</a>
                <div class="dropdown-divider"></div>
                <button class="dropdown-item" (click)="logout()">Logout</button>
              </div>
            </li>
          </ul>


          <ng-template #notLoggedIn>
            <ul class="navbar-nav flex-grow">
              <!--<li class="nav-item loginButton">
                <a class="nav-link loginButtonText" [routerLink]="['/login']"> Login </a>
              </li>-->
            </ul>

          </ng-template>
        </div>
      </div>
    </nav>
  </header>
